/**
 * @ignore
 */
import React, { isValidElement } from 'react';
function isChildFunc(arg) {
    return typeof arg === 'function';
}
/**
 * Helper component to render a single item component.
 *
 * Sets correct Context, allows data to be accessed via Render Function or later via context.
 */
export function ItemChildren({ children, Provider, data, }) {
    return (React.createElement(Provider, { value: data.id }, React.isValidElement(children)
        ? children
        : isChildFunc(children)
            ? children(data)
            : null));
}
/**
 * Helper component to render Collection components.
 *
 * Sets correct Context, allows data to be accessed via Render Function or later via context.
 */
export function CollectionChildren({ children, data, Provider, }) {
    // Doing this for the stable obj created.
    const ids = React.useMemo(() => data.map((c) => c.id), [data]);
    return (React.createElement(Provider, { value: ids }, isValidElement(children)
        ? children
        : isChildFunc(children)
            ? children(data)
            : null));
}
/**
 * Helper component to handle Loop components.
 *
 * Loops over an array of items and sets correct Context, allows data to be accessed via Render Function or later via context.
 */
export function LoopItemChildren({ children, data, dataKey, Provider, }) {
    return (React.createElement(React.Fragment, null, data.map((i, index) => {
        const item = {
            [dataKey]: i,
            index,
        };
        return (React.createElement(Provider, { key: i.id, value: i.id }, React.isValidElement(children)
            ? children
            : isChildFunc(children)
                ? children(item)
                : null));
    })));
}
//# sourceMappingURL=utils.js.map